module.exports = __webpack_public_path__ + "static/media/campus_wireflow1.c8017c68.jpg";